var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleAppStoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8137 12.6443C16.7844 9.58205 19.3726 8.09205 19.4911 8.02217C18.0266 5.92692 15.7539 5.64022 14.9572 5.61761C13.0482 5.42031 11.199 6.73768 10.2283 6.73768C9.23551 6.73768 7.73853 5.63816 6.12728 5.66796C4.05059 5.70085 2.10913 6.87846 1.043 8.70757C-1.15425 12.4367 0.486349 17.9168 2.5903 20.9318C3.6428 22.4074 4.87456 24.0587 6.48476 23.9981C8.06141 23.9354 8.64951 23.0137 10.5522 23.0137C12.436 23.0137 12.9895 23.9981 14.6332 23.9621C16.3242 23.9354 17.3882 22.4793 18.405 20.9893C19.6221 19.2979 20.1106 17.6312 20.1306 17.5459C20.0897 17.5325 16.8462 16.3169 16.8137 12.6443Z",
    fill: "#434343"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7116 3.88737C14.5586 2.84745 15.1393 1.43554 14.979 0C13.7524 0.0544622 12.2167 0.832347 11.335 1.84863C10.5509 2.74366 9.85274 4.21312 10.0351 5.59111C11.4116 5.69182 12.8257 4.91085 13.7116 3.88737Z",
    fill: "#434343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleAppStoreIcon);
export default __webpack_public_path__ + "static/media/apple-app-store-icon.567a033954f7f3e27d0e8e81bf274a1c.svg";
export { ForwardRef as ReactComponent };